// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"386":"122736c5","8920":"0ef3a24e"}[chunkId] + ".chunk.css";
};